function Playground() {
  const cards = [
    { label: 'weird buttons', href: '/weird-buttons' },
    { label: 'Coming soon...' },
    { label: 'Coming soon...' },
    { label: 'Coming soon...' },
    { label: 'Coming soon...' },
    { label: 'Coming soon...' },
    { label: 'Coming soon...' },
    { label: 'Coming soon...' },
  ]

  return (
    <section className="playground" aria-label="Playground">
      <div>
        <p className="eyebrow">Playground</p>
        <h1>Experiment space</h1>
        <p className="subtitle">This page is ready for new ideas. We can build it out next.</p>
      </div>
      <div className="playground-grid" aria-label="Playground cards">
        {cards.map((card, index) =>
          card.href ? (
            <a className="playground-card is-link" href={card.href} key={`${card.label}-${index}`}>
              <span>{card.label}</span>
            </a>
          ) : (
            <article className="playground-card" key={`${card.label}-${index}`}>
              <span>{card.label}</span>
            </article>
          )
        )}
      </div>
      <a className="back-link" href="/portfolio">
        View portfolio
      </a>
    </section>
  )
}

export default Playground
